import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '../../components/layout/PageHeader';
import { UsageView } from '../../components/usage/UsageView';

function UsageCustomerPage() {
  return (
    <>
      <PageHeader title="Kullanım" description="Sağlayıcı tüketiminiz" />
      <UsageView />
    </>
  );
}

export const Route = createFileRoute('/_app/usage')({ component: UsageCustomerPage });
